export class TiposId {
  public tipoId?: string;
  public description?: string;
  public descriptionEn?: string;
  public descriptionDe?: string;
}
